var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("ANESTHESIOLOGIST")]),_c('h4',[_vm._v(" A specialist duly licensed and registered to administer anesthetic agents and conduct other anesthesia procedures during medical operation. ")])])
}]

export { render, staticRenderFns }